import axios from '../utils/index'

// 数据检索接口
export function pageSearch(params) {
  return axios.get('/portal/book/pageSearch', {params})
}

// 获取单页识别结果接口
export function getPageContent(params) {
  return axios.get('/portal/book/getPageContent', {params})
}

// 获取单页识别结果接口
export function view(params) {
  return axios.get('/portal/book/view', {params})
}

// 前台获取对照页书籍信息新接口
export function getReferencePage(params) {
  return axios.get('/portal/book/getReferencePage', {params})
}

// 前台查询某页图片关联资源接口

export function listRelationByBookIdFileName(params) {
  return axios.get('/portal/relation/listRelationByBookIdFileName', {params})
}

// 前台查询某页图片关联资源接口

export function getNotes(params) {
  return axios.get('/portal/book/getNotes', {params})
}
